import axios from "axios";
import { getToken } from "./auth";

import { API_URL } from './config';
const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const getRoles = async (params = {}) =>
  (await axios.get(`${API_URL}/roles`, { ...withAuth(), params })).data;
